import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import VueGtm from "@gtm-support/vue2-gtm";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  /*
   ** 管理者
   */
  // 管理者ダッシュボード
  {
    path: "/admin",
    name: "MDashboard",
    component: () => import(/* webpackChunkName: "manager-dashboard" */ "../views/manager/MDashboard.vue"),
  },
  // 管理者ログイン
  {
    path: "/admin/login",
    name: "MLogin",
    component: () => import(/* webpackChunkName: "manager-login" */ "../views/manager/MLogin.vue"),
  },
  // 管理者パスワード再設定申請
  {
    path: "/admin/reset-pass",
    name: "MResetPass",
    component: () => import(/* webpackChunkName: "manager-reset-pass-app" */ "../views/manager/MResetPass.vue"),
  },
  // 管理者パスワード再設定メール送信
  {
    path: "/admin/reset-pass/email-sending",
    name: "MResetPassEmail",
    component: () => import(/* webpackChunkName: "manager-reset-pass-email" */ "../views/manager/MResetPassEmail.vue"),
  },
  // 管理者パスワード再設定
  {
    path: "/admin/reset-pass/set-pass",
    name: "MResetPassSet",
    component: () => import(/* webpackChunkName: "manager-reset-pass-set" */ "../views/manager/MResetPassSet.vue"),
  },
  // 管理者パスワード再設定完了
  {
    path: "/admin/reset-pass/complete",
    name: "MResetPassComp",
    component: () =>
      import(/* webpackChunkName: "manager-reset-pass-complete" */ "../views/manager/MResetPassComp.vue"),
  },
  // 管理者メール再送信
  {
    path: "/admin/pre-register-resend",
    name: "MPreRegisterResend",
    component: () =>
      import(/* webpackChunkName: "manager-pre-register-resend" */ "../views/manager/MPreRegisterResend.vue"),
  },
  // 管理者メール再送信完了
  {
    path: "/admin/pre-register-resend/complete",
    name: "MPreRegisterResendComp",
    component: () =>
      import(/* webpackChunkName: "manager-pre-register-resend-comp" */ "../views/manager/MPreRegisterResendComp.vue"),
  },
  // 管理者仮登録の完了
  {
    path: "/admin/pre-register/complete",
    name: "MPreRegisterComp",
    component: () =>
      import(/* webpackChunkName: "manager-pre-register-complete" */ "../views/manager/MPreRegisterComp.vue"),
  },
  // 管理者一覧
  {
    path: "/admin/admin-list",
    name: "MAdminList",
    component: () => import(/* webpackChunkName: "manager-admin-list" */ "../views/manager/MAdminList.vue"),
  },
  // 管理者登録情報編集
  {
    path: "/admin/register-info-edit",
    name: "MRegisterInfoEdit",
    component: () =>
      import(/* webpackChunkName: "manager-register-info-edit" */ "../views/manager/MRegisterInfoEdit.vue"),
  },
  // 管理者登録情報編集完了
  {
    path: "/admin/register-info-edit/complete",
    name: "MRegisterInfoEditComp",
    component: () =>
      import(
        /* webpackChunkName: "manager-register-info-edit-complete" */ "../views/manager/MRegisterInfoEditComp.vue"
      ),
  },
  // 管理者登録メールアドレス編集
  {
    path: "/admin/register-email-edit",
    name: "MRegisterEmailEdit",
    component: () => import(/* webpackChunkName: "register-email-edit" */ "../views/manager/MRegisterEmailEdit.vue"),
  },
  // 管理者登録メールアドレス編集完了
  {
    path: "/admin/register-email-edit/complete",
    name: "MRegisterEmailEditComp",
    component: () =>
      import(/* webpackChunkName: "register-email-edit-comp" */ "../views/manager/MRegisterEmailEditComp.vue"),
  },
  // 管理者登録パスワード編集
  {
    path: "/admin/register-pass-edit",
    name: "MRegisterPassEdit",
    component: () => import(/* webpackChunkName: "register-pass-edit" */ "../views/manager/MRegisterPassEdit.vue"),
  },
  // 管理者登録パスワード編集完了
  {
    path: "/admin/register-pass-edit/complete",
    name: "MRegisterPassEditComp",
    component: () =>
      import(/* webpackChunkName: "register-pass-edit-comp" */ "../views/manager/MRegisterPassEditComp.vue"),
  },
  // 管理者側からみたユーザー一覧
  {
    path: "/admin/user-list",
    name: "MUserList",
    component: () => import(/* webpackChunkName: "manager-user-list" */ "../views/manager/MUserList.vue"),
  },
  // 管理者側からみたユーザー詳細
  {
    path: "/admin/user-list/detail/:uuid",
    name: "MUserListDetail",
    component: () => import(/* webpackChunkName: "manager-user-list-detail" */ "../views/manager/MUserListDetail.vue"),
  },
  // 管理者側教材一覧
  {
    path: "/admin/teaching-material",
    name: "Material",
    component: () => import(/* webpackChunkName: "manager-material-list" */ "../views/manager/MMaterialList.vue"),
  },
  // 管理者側教材詳細
  {
    path: "/admin/teaching-material/section-list/:content",
    name: "MaterialDetail",
    component: () =>
      import(/* webpackChunkName: "manager-material-detail" */ "../views/manager/MMaterialListDetail.vue"),
  },
  // 管理者側教材編集
  {
    path: "/admin/teaching-material/edit/:content",
    name: "MaterialEdit",
    component: () => import(/* webpackChunkName: "manager-material-edit" */ "../views/manager/MMaterialEdit.vue"),
  },
  // 管理者側教材登録
  {
    path: "/admin/teaching-material/register",
    name: "MaterialRegister",
    component: () =>
      import(/* webpackChunkName: "manager-material-register" */ "../views/manager/MMaterialRegister.vue"),
  },
  // 管理者お知らせ一覧
  {
    path: "/admin/news",
    name: "MNewsList",
    component: () => import(/* webpackChunkName: "manager-news-list" */ "../views/manager/MNewsList.vue"),
  },
  // 管理者チャット
  {
    path: "/admin/chat",
    name: "MChat",
    component: () => import(/* webpackChunkName: "admin-chat" */ "../views/manager/MChat.vue"),
  },
  // 管理者団体一覧
  {
    path: "/admin/organization-list",
    name: "MOrganizationList",
    component: () => import(/* webpackChunkName: "admin-organization-list" */ "../views/manager/MOrganizationList.vue"),
  },
  // 管理者団体詳細
  {
    path: "/admin/organization-list/detail/:uuid",
    name: "MOrganizationDetail",
    component: () =>
      import(/* webpackChunkName: "admin-organization-list-detail" */ "../views/manager/MOrganizationDetail.vue"),
  },
  // 管理者団体所属ユーザー詳細
  {
    path: "/admin/organization/:uuid/user-list",
    name: "MOrganizationUserList",
    component: () =>
      import(/* webpackChunkName: "admin-organization-user-list" */ "../views/manager/MOrganizationUserList.vue"),
  },

  /*
   ** ユーザー
   */
  // ユーザーダッシュボード
  {
    path: "/user",
    name: "UDashboard",
    component: () => import(/* webpackChunkName: "user-dashboard" */ "../views/user/UDashboard.vue"),
  },
  // ユーザログイン
  {
    path: "/user/login",
    name: "ULogin",
    component: () => import(/* webpackChunkName: "user-login" */ "../views/user/ULogin.vue"),
  },
  // ユーザーパスワード再設定申請
  {
    path: "/user/reset-pass",
    name: "UResetPass",
    component: () => import(/* webpackChunkName: "user-reset-pass" */ "../views/user/UResetPass.vue"),
  },
  // ユーザーパスワード再設定メール送信
  {
    path: "/user/reset-pass/email-sending",
    name: "UResetPassEmail",
    component: () => import(/* webpackChunkName: "user-reset-pass-email" */ "../views/user/UResetPassEmail.vue"),
  },
  // ユーザーパスワード再設定
  {
    path: "/user/reset-pass/set-pass",
    name: "UResetPassSet",
    component: () => import(/* webpackChunkName: "user-reset-pass-set" */ "../views/user/UResetPassSet.vue"),
  },
  // ユーザーパスワード再設定完了
  {
    path: "/user/reset-pass/complete",
    name: "UResetPassComp",
    component: () => import(/* webpackChunkName: "user-reset-pass-complete" */ "../views/user/UResetPassComp.vue"),
  },
  // ユーザーメール再送信
  {
    path: "/user/pre-register-resend",
    name: "UPreRegisterResend",
    component: () => import(/* webpackChunkName: "user-pre-register-resend" */ "../views/user/UPreRegisterResend.vue"),
  },
  // ユーザーメール再送信完了
  {
    path: "/user/pre-register-resend/complete",
    name: "UPreRegisterResendComp",
    component: () =>
      import(/* webpackChunkName: "user-pre-register-resend-comp" */ "../views/user/UPreRegisterResendComp.vue"),
  },
  // ユーザー仮登録
  {
    path: "/user/pre-register",
    name: "UPreRegister",
    component: () => import(/* webpackChunkName: "user-pre-register" */ "../views/user/UPreRegister.vue"),
  },
  // ユーザー仮登録完了
  {
    path: "/user/pre-register/complete",
    name: "UPreRegisterComp",
    component: () => import(/* webpackChunkName: "user-pre-register-complete" */ "../views/user/UPreRegisterComp.vue"),
  },
  // ユーザー本登録
  {
    path: "/user/register",
    name: "URegister",
    component: () => import(/* webpackChunkName: "user-register" */ "../views/user/URegister.vue"),
  },
  // 管理者からの招待ユーザー本登録
  {
    path: "/user/register/invitation",
    name: "URegisterByAdmin",
    component: () => import(/* webpackChunkName: "user-register-invitation" */ "../views/user/URegisterByAdmin.vue"),
  },
  // ユーザー本登録完了
  {
    path: "/user/register/complete",
    name: "URegisterComp",
    component: () => import(/* webpackChunkName: "user-register-complete" */ "../views/user/URegisterComp.vue"),
  },
  // ユーザープレミアム会員登録
  {
    path: "/user/payment",
    name: "URegisterPlan",
    component: () => import(/* webpackChunkName: "user-register-plan" */ "../views/user/URegisterPlan.vue"),
  },
  // ユーザー登録情報
  {
    path: "/user/register-info",
    name: "URegisterInfo",
    component: () => import(/* webpackChunkName: "user-register-info-edit" */ "../views/user/URegisterInfo.vue"),
  },
  // ユーザー登録情報編集
  {
    path: "/user/register-info-edit",
    name: "URegisterInfoEdit",
    component: () => import(/* webpackChunkName: "user-register-info-edit" */ "../views/user/URegisterInfoEdit.vue"),
  },
  // ユーザー登録情報編集完了
  {
    path: "/user/register-info-edit/complete",
    name: "URegisterInfoEditComp",
    component: () =>
      import(/* webpackChunkName: "user-register-info-edit-complete" */ "../views/user/URegisterInfoEditComp.vue"),
  },
  // ユーザー登録プランに関する情報
  {
    path: "/user/register-payment",
    name: "URegisterPayment",
    component: () => import(/* webpackChunkName: "register-payment" */ "../views/user/URegisterPayment.vue"),
  },
  // ユーザー登録プランに関する情報編集
  {
    path: "/user/register-payment-edit/:edit",
    name: "URegisterPaymentEdit",
    component: () => import(/* webpackChunkName: "register-payment-edit" */ "../views/user/URegisterPaymentEdit.vue"),
  },
  // ユーザー登録メールアドレス編集
  {
    path: "/user/register-email-edit",
    name: "URegisterEmailEdit",
    component: () => import(/* webpackChunkName: "register-email-edit" */ "../views/user/URegisterEmailEdit.vue"),
  },
  // ユーザー登録メールアドレス完了
  {
    path: "/user/register-email-edit/complete",
    name: "URegisterEmailEditComp",
    component: () =>
      import(/* webpackChunkName: "register-email-edit-comp" */ "../views/user/URegisterEmailEditComp.vue"),
  },
  // ユーザー登録パスワード編集
  {
    path: "/user/register-pass-edit",
    name: "URegisterPassEdit",
    component: () => import(/* webpackChunkName: "register-pass-edit" */ "../views/user/URegisterPassEdit.vue"),
  },
  // ユーザー登録パスワード完了
  {
    path: "/user/register-pass-edit/complete",
    name: "URegisterPassEditComp",
    component: () =>
      import(/* webpackChunkName: "register-pass-edit-comp" */ "../views/user/URegisterPassEditComp.vue"),
  },
  // ユーザーチャット
  {
    path: "/user/chat",
    name: "UChat",
    component: () => import(/* webpackChunkName: "user-chat" */ "../views/user/UChat.vue"),
  },
  // ユーザーカテゴリー一覧
  {
    path: "/user/category",
    name: "UCategory",
    component: () => import(/* webpackChunkName: "user-category" */ "../views/user/UCategory.vue"),
  },
  // ユーザー教材 コンテンツ一覧
  {
    path: "/user/category/:category/",
    name: "UContents",
    component: () => import(/* webpackChunkName: "user-category-uuid" */ "../views/user/UContents.vue"),
  },
  // ユーザー教材 コンテンツ（各セクション）
  {
    path: "/user/category/:category/:content",
    name: "UContent",
    component: () => import(/* webpackChunkName: "user-category-uuid-uuid" */ "../views/user/UContent.vue"),
  },
  // ユーザー利用方法
  {
    path: "/user/how-to-use",
    name: "UHowToUse",
    component: () => import(/* webpackChunkName: "user-how-to-use" */ "../views/user/UHowToUse.vue"),
  },
  /*
   ** 団体管理者
   */
  // 団体管理者ダッシュボード
  {
    path: "/organization",
    name: "ODashboard",
    component: () => import(/* webpackChunkName: "organization" */ "../views/organization/ODashboard.vue"),
  },
  // 団体管理者ログイン
  {
    path: "/organization/login",
    name: "OLogin",
    component: () => import(/* webpackChunkName: "organization-login" */ "../views/organization/OLogin.vue"),
  },
  // 団体管理者パスワード再設定申請
  {
    path: "/organization/reset-pass",
    name: "OResetPass",
    component: () => import(/* webpackChunkName: "organization-reset-pass" */ "../views/organization/OResetPass.vue"),
  },
  // 団体管理者パスワード再設定メール送信
  {
    path: "/organization/reset-pass/email-sending",
    name: "OResetPassEmail",
    component: () =>
      import(/* webpackChunkName: "organization-reset-pass-email" */ "../views/organization/OResetPassEmail.vue"),
  },
  // 団体管理者パスワード再設定
  {
    path: "/organization/reset-pass/set-pass",
    name: "OResetPassSet",
    component: () =>
      import(/* webpackChunkName: "organization-reset-pass-set" */ "../views/organization/OResetPassSet.vue"),
  },
  // 団体管理者パスワード再設定完了
  {
    path: "/organization/reset-pass/complete",
    name: "OResetPassComp",
    component: () =>
      import(/* webpackChunkName: "organization-reset-pass-complete" */ "../views/organization/OResetPassComp.vue"),
  },
  // 団体管理者登録メールアドレス編集
  {
    path: "/organization/register-email-edit",
    name: "ORegisterEmailEdit",
    component: () =>
      import(/* webpackChunkName: "organization-register-email-edit" */ "../views/organization/ORegisterEmailEdit.vue"),
  },
  // 団体管理者登録メールアドレス完了
  {
    path: "/organization/register-email-edit/complete",
    name: "ORegisterEmailEditComp",
    component: () =>
      import(
        /* webpackChunkName: "organization-register-email-edit-comp" */ "../views/organization/ORegisterEmailEditComp.vue"
      ),
  },
  // 団体管理者登録パスワード編集
  {
    path: "/organization/register-pass-edit",
    name: "ORegisterPassEdit",
    component: () =>
      import(/* webpackChunkName: "organization-register-pass-edit" */ "../views/organization/ORegisterPassEdit.vue"),
  },
  // 団体管理者登録パスワード完了
  {
    path: "/organization/register-pass-edit/complete",
    name: "ORegisterPassEditComp",
    component: () =>
      import(
        /* webpackChunkName: "organization-register-pass-edit-comp" */ "../views/organization/ORegisterPassEditComp.vue"
      ),
  },
  // 団体管理者登録情報
  {
    path: "/organization/register-info",
    name: "ORegisterInfo",
    component: () =>
      import(/* webpackChunkName: "organization-register-info" */ "../views/organization/ORegisterInfo.vue"),
  },
  // 団体管理者登録情報編集
  {
    path: "/organization/register-info-edit",
    name: "ORegisterInfoEdit",
    component: () =>
      import(/* webpackChunkName: "organization-register-info-edit" */ "../views/organization/ORegisterInfoEdit.vue"),
  },
  // 団体管理者登録情報編集完了
  {
    path: "/organization/register-info-edit/complete",
    name: "ORegisterInfoEditComp",
    component: () =>
      import(
        /* webpackChunkName: "organization-register-info-edit-complete" */ "../views/organization/ORegisterInfoEditComp.vue"
      ),
  },
  // 団体管理者一覧
  {
    path: "/organization/admin-list",
    name: "OAdminList",
    component: () => import(/* webpackChunkName: "organization-admin-list" */ "../views/organization/OAdminList.vue"),
  },
  // 団体所属ユーザー一覧
  {
    path: "/organization/user-list",
    name: "OUserList",
    component: () => import(/* webpackChunkName: "organization-user-list" */ "../views/organization/OUserList.vue"),
  },
  // 団体所属ユーザー詳細
  {
    path: "/organization/user-list/detail/:uuid",
    name: "OUserDetail",
    component: () =>
      import(/* webpackChunkName: "organization-user-list-detail" */ "../views/organization/OUserDetail.vue"),
  },
  // 団体カテゴリー一覧
  {
    path: "/organization/category",
    name: "OCategory",
    component: () => import(/* webpackChunkName: "organization-category" */ "../views/organization/OCategory.vue"),
  },
  // 団体教材 コンテンツ一覧
  {
    path: "/organization/category/:category/",
    name: "OContents",
    component: () => import(/* webpackChunkName: "organization-category-uuid" */ "../views/organization/OContents.vue"),
  },
  // 団体教材 コンテンツ（各セクション）
  {
    path: "/organization/category/:category/:content",
    name: "OContent",
    component: () =>
      import(/* webpackChunkName: "organization-category-uuid-uuid" */ "../views/organization/OContent.vue"),
  },
  // 団体管理者 チャット
  {
    path: "/organization/chat",
    name: "OChat",
    component: () => import(/* webpackChunkName: "organization-chat" */ "../views/organization/OChat.vue"),
  },
  /*
   ** 共通
   */

  // トップページ
  {
    path: "/",
    name: "Top",
    component: () => import(/* webpackChunkName: "top" */ "../views/Top.vue"),
  },
  // 教材一覧（紹介）
  {
    path: "/materials",
    name: "Materials",
    component: () => import(/* webpackChunkName: "materials" */ "../views/Materials.vue"),
  },
  // 利用規約
  {
    path: "/tos",
    name: "Tos",
    component: () => import(/* webpackChunkName: "tos" */ "../views/Tos.vue"),
  },
  // プライバシーポリシー
  {
    path: "/privacy",
    name: "Privacy",
    component: () => import(/* webpackChunkName: "privacy" */ "../views/Privacy.vue"),
  },
  // お問い合わせ
  {
    path: "/contact",
    name: "Contact",
    component: () => import(/* webpackChunkName: "contact" */ "../views/Contact.vue"),
  },
  // メンテナスページ
  {
    path: "/maintenance",
    name: "Maintenance",
    component: () => import(/* webpackChunkName: "maintenance" */ "../views/Maintenance.vue"),
  },
];

export const managerRoutes: Array<RouteConfig> = [
  // 管理者仮登録
  {
    path: "/admin/pre-register",
    name: "MPreRegister",
    component: () => import(/* webpackChunkName: "manager-pre-register" */ "../views/manager/MPreRegister.vue"),
  },
  // 管理者本登録完了
  {
    path: "/admin/register",
    name: "MRegister",
    component: () => import(/* webpackChunkName: "manager-register" */ "../views/manager/MRegister.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes: process.env.VUE_APP_MODE !== "production" ? routes.concat(managerRoutes) : routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    // 望みのポジションを返す
    return { x: 0, y: 0 };
  },
});

if (process.env.NODE_ENV === "production") {
  Vue.use(VueGtm, {
    id: "GTM-54HXSDS",
    vueRouter: router,
  });
}

export default router;
